module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDIwIDEwIj4KICA8cGF0aCBpZD0i44OR44K5XzEyNzQiIGRhdGEtbmFtZT0i44OR44K5IDEyNzQiIGQ9Ik0xMiwxMy4wNzksMiw0LjQ0MiwzLjU1MywzLjA3OSwxMiwxMC41ODdsOC43LTcuNTA4TDIyLDQuNDQyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTMuMDc5KSIgZmlsbD0iIzU1NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-card-display-icon.svg
// module id = l9jg
// module chunks = 3